function e(e,o){Object.entries(e).forEach((e=>{let[t,r]=e;void 0!==r&&(o[t.toLowerCase()]=r)}))}export{e as parseStyleObject};
//# sourceMappingURL=parseStyleObject.min.mjs.map
